import { Box, Button, Checkbox, FormControl, FormErrorMessage, FormLabel, Heading, Input, Select, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { Form, Formik, useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ModalLoading from '../../../components/Loader/ModalLoader.jsx';
import { urlNavigate } from '../../../helper/utils/navigation.js';
import { doHandleState, doLogin } from '../../../redux/waiver/waiver.actions.js';
import FormLayoutProvider from '../../layout/FormLayoutProvider.jsx';
import { UserRegistrationSchema } from '../../waiver/hooks/validation.js';

export default function MembershipLogin() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
            brand: '',
        },
        onSubmit: (values) => dispatch(doLogin(values, navigate)),
        validationSchema: UserRegistrationSchema,
    });

    const handleChangeBrand = (v) => dispatch(doHandleState('brandCode', v));

    const { loadingSignIn = false } = useSelector((s) => s?.waiver);

    return (
        <FormLayoutProvider>
            <ModalLoading loading={loadingSignIn} />
            <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12}>
                <Stack align={'center'}>
                    <Heading fontSize={'xl'}>Sign In</Heading>
                </Stack>
                <Box rounded={'lg'} bg={useColorModeValue('white', 'gray.700')} boxShadow={'lg'} p={8}>
                    <Stack spacing={4}>
                        <Formik onSubmit={formik.handleSubmit} initialValues={formik.initialValues}>
                            <Form>
                                <FormControl id='email' isInvalid={!!formik?.errors.email && formik?.touched.email}>
                                    <FormLabel>{t('email')}</FormLabel>
                                    <Input size='lg' id='email' name='email' type='email' onChange={formik.handleChange} value={formik?.values?.email ?? ''} placeholder={t('please_fill_email')} />
                                    <FormErrorMessage>{formik?.errors.email}</FormErrorMessage>
                                </FormControl>
                                <FormControl id='password' isInvalid={!!formik?.errors.password && formik?.touched.password}>
                                    <FormLabel>Password</FormLabel>
                                    <Input type='password' size='lg' id='password' name='password' onChange={formik.handleChange} value={formik?.values?.password ?? ''} placeholder={t('please_fill_password')} />
                                    <FormErrorMessage>{formik?.errors.password}</FormErrorMessage>
                                </FormControl>
                                <FormControl id='password' isInvalid={!!formik?.errors.brand && formik?.touched.brand}>
                                    <FormLabel>Brand</FormLabel>
                                    <Select
                                        placeholder='Select Brand'
                                        onChange={(v) => {
                                            formik.handleChange(v);
                                            handleChangeBrand(v?.target?.value);
                                        }}
                                        id='brand'
                                        name='brand'>
                                        <option value='pororo'>Pororo</option>
                                        <option value='superpark'>Superpark</option>
                                    </Select>
                                    <FormErrorMessage>{formik?.errors.brand}</FormErrorMessage>
                                </FormControl>

                                <Stack spacing={20}>
                                    <Stack mt={4} direction={{ base: 'column', sm: 'row' }} align={'start'} justify={'space-between'}>
                                        <Checkbox>{t('remember_me')}</Checkbox>
                                        <Text color={'blue.400'} onClick={() => navigate('/membership/forgot')} pointerEvents='stroke'>
                                            {t('forgot_password')}
                                        </Text>
                                    </Stack>
                                </Stack>
                                <Stack spacing={4} my={8}>
                                    <Button
                                        type='submit'
                                        bg={'red.400'}
                                        color={'white'}
                                        _hover={{
                                            bg: 'red.500',
                                        }}>
                                        {t('login')}
                                    </Button>

                                    <Button onClick={() => navigate(urlNavigate('online-sales', 'home'))}>{t('fill_waiver')}</Button>
                                </Stack>
                            </Form>
                        </Formik>
                    </Stack>
                </Box>
            </Stack>
        </FormLayoutProvider>
    );
}
